import type { EEGVersionDetailed } from "../../../types/api.types";
import { getEegVersionLabel } from "./getEegVersionLabel";

/** Combines EEG version and applied § 51 rule into one label, e.g. "EEG 2023 | 4-Stunden-Regel". */
export function getEegStundenregelLabel(
  eegVersion: EEGVersionDetailed | null | undefined,
  appliedP51Rule: string | null | undefined
): string | null {
  const versionLabel = eegVersion ? getEegVersionLabel(eegVersion) : null;
  if (versionLabel && appliedP51Rule) {
    return `${versionLabel} | ${appliedP51Rule}`;
  }
  return versionLabel ?? appliedP51Rule ?? null;
}
